/** @format */
import { stringify } from 'qs';

import {
    convertKeyNames,
    toSnakeCase,
} from '@toucan/client/global/axios/helpers/interceptors/change-case';

export function getProductIdFromSkuQueryParams(sku: string, slug: string) {
    return stringify(
        convertKeyNames(
            {
                urlSegment: slug,
                sku,
            },
            toSnakeCase
        ),
        {
            encodeValuesOnly: true,
            arrayFormat: 'repeat',
        }
    );
}
